import { MapPin, Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { HOTEL, NAV_LINKS } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0F0707] text-white/85 pt-20 pb-10 grain"
    >
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" />

      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full overflow-hidden ring-1 ring-[#D4AF37]/40 bg-[#7A1A24]">
              <img
                src={HOTEL.logo}
                alt="Maa Durga Palace & Guest House logo"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </span>
            <div>
              <div className="font-display text-lg text-white">Maa Durga Palace</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                & Guest House
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/65 leading-relaxed max-w-md">
            A comfortable, affordable, family-friendly hotel & guest house in Bagurai,
            Bhadrak — built on genuine Odia hospitality.
          </p>

          <div className="mt-7 flex gap-3">
            <a
              href={`tel:${HOTEL.phoneE164}`}
              data-testid="footer-call"
              className="btn-gold !py-2.5 !px-4 text-xs"
            >
              <Phone size={14} />
              Call Now
            </a>
            <a
              href={HOTEL.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="btn-whatsapp !py-2.5 !px-4 text-xs"
            >
              <MessageCircle size={14} />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-white/70 hover:text-white transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Visit</div>
          <div className="flex items-start gap-3 text-sm">
            <MapPin size={16} className="mt-0.5 text-[#D4AF37] shrink-0" />
            <span className="text-white/75 leading-relaxed">
              {HOTEL.address.line1},<br />
              {HOTEL.address.city}, {HOTEL.address.state} {HOTEL.address.pin}
            </span>
          </div>
          <a
            href={HOTEL.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex text-xs text-[#D4AF37] hover:underline"
          >
            Open in Google Maps →
          </a>

          <div className="mt-6 text-xs text-white/55 space-y-1">
            <div>Check-in: <span className="text-white/80">{HOTEL.checkIn}</span></div>
            <div>Check-out: <span className="text-white/80">{HOTEL.checkOut}</span></div>
          </div>
        </div>
      </div>

      <div className="container-x mt-14 pt-6 border-t border-white/10 flex flex-col gap-3 items-center text-xs text-white/50">
        <div className="flex flex-col sm:flex-row gap-3 items-center justify-between w-full">
          <div>© {new Date().getFullYear()} Maa Durga Palace & Guest House. All rights reserved.</div>
          <div>Crafted with care in Bhadrak, Odisha</div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          data-testid="footer-credit"
          className="text-[11px] tracking-wide text-white/35"
        >
          Designed & Developed by{" "}
          <a
            href="https://wa.me/919437102852?text=Hi%2C%20I%20saw%20the%20Maa%20Durga%20Palace%20website%20by%20SM%20Web%20Solution"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-[#D4AF37]/80 hover:text-[#D4AF37] underline-offset-4 hover:underline transition-colors"
          >
            SM Web Solution
          </a>
        </motion.div>
      </div>
    </footer>
  );
}
